import { render, staticRenderFns } from "./InvoiceKnowledge.vue?vue&type=template&id=c795793a&scoped=true&"
import script from "./InvoiceKnowledge.vue?vue&type=script&lang=js&"
export * from "./InvoiceKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c795793a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c795793a')) {
      api.createRecord('c795793a', component.options)
    } else {
      api.reload('c795793a', component.options)
    }
    module.hot.accept("./InvoiceKnowledge.vue?vue&type=template&id=c795793a&scoped=true&", function () {
      api.rerender('c795793a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/invoice/invoice-received/components/InvoiceKnowledge.vue"
export default component.exports